import { render, staticRenderFns } from "./ConstructionNewFormSection.vue?vue&type=template&id=20060e5e&scoped=true&lang=pug&"
import script from "./ConstructionNewFormSection.vue?vue&type=script&lang=ts&"
export * from "./ConstructionNewFormSection.vue?vue&type=script&lang=ts&"
import style0 from "./ConstructionNewFormSection.vue?vue&type=style&index=0&id=20060e5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20060e5e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDatePicker } from 'vuetify/lib/components/VDatePicker';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCol,VDatePicker,VMenu,VRow,VSelect,VTextField,VTextarea})
